import React, { useContext } from 'react';
import _ from 'lodash';
import Highlighter from 'react-highlight-words';
import TableContext from '../TableContext';

const CellValueHighlighter = ({ cellValue }) => {
  const { query, isQueryActive } = useContext(TableContext);
  if (!cellValue) {
    return null;
  }
  if (!isQueryActive) {
    return cellValue;
  }

  return (
    <Highlighter
      searchWords={[query]}
      textToHighlight={_.toString(cellValue)}
      autoEscape
    />
  );
};

export default CellValueHighlighter;
